import Phrase from '../../libs/translationsUtils/phrase'

const ShowMoreButton = ({ callback, count }) => {
  return <span className=' show-more' onClick={callback} >
    <Phrase p='show.more' count={{ number: count }} />
  </span>
}

export default ShowMoreButton
